import { render, staticRenderFns } from "./RollCallSetDetail.vue?vue&type=template&id=18656f68&scoped=true"
import script from "./RollCallSetDetail.vue?vue&type=script&lang=js"
export * from "./RollCallSetDetail.vue?vue&type=script&lang=js"
import style1 from "./RollCallSetDetail.vue?vue&type=style&index=1&id=18656f68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18656f68",
  null
  
)

export default component.exports